<div class="dropdown-container">
	 <div class="dropdown" ngbDropdown>
			<button ngbDropdownToggle
			  id="grid-settings-menu-button"
			  type="button"
			  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
			  aria-haspopup="true"
			  aria-expanded="false"
			  aria-label="Grid settings"
			  title="Select grid columns"
			  style="border: 0; background: transparent;">
				<i class="result-nav-icon fa fa-cog" aria-hidden="true"></i>
			</button>								  
	      <ul class="dropdown-menu dropdown-menu-results custom-drop" ngbDropdownMenu aria-labelledby="grid-settings-menu-button" role="menu" 
	      	  placement="bottom-end" 
	      	  style="max-width: 250px; min-width: 200px; overflow-x: auto; padding: 2px 4px !important;">
	        <li *ngFor="let col of allColumns" role="menuitem">
	          <label class="ui-grid-tools-menu-label">
		          <input
		            type="checkbox"
		            [checked]="col.isVisible()"
		            (change)="toggleColumn(col.getColId(), $event)"
		          />
		          {{ col.getColDef().headerName }}
	          </label>
	        </li>	    
	    </ul>
	</div>
</div>
